export default "__VITE_ASSET__B8RkLI5f__"